import request from '@/utils/request'

export function getOpList() {
  return request({
    url: '/vue-element-admin/dashboard/getOpList',
    method: 'post',
  })
}
export function getMessageList() {
    return request({
        url: '/vue-element-admin/dashboard/messageList',
        method: 'post',
    })
}
export function getRecommendationList() {
  return request({
    url: '/vue-element-admin/dashboard/getRecommendationList',
    method: 'post',
  })


}
